<div class="">
    <div class="modal-header">
        <h4 class="modal-title kx-modal-heading pl-2">
            <strong>{{title}}</strong>
        </h4>
    </div>
    <div class="modal-body">
        <ng-container>
            <div class="row">
                <audio id="play_ringtone" loop="loop">
                    <source src="{{origin}}/assets/ringtone/ringtone-for-call.mp3" type="audio/ogg">
                    <source src="{{origin}}/assets/ringtone/ringtone-for-call.mp3" type="audio/mpeg">
                </audio>
                <div class="col-6">
                    <button class="primary-btn btn-lg" (click)="hasCall()"><i
                            class="fa fa-video-camera fa-lg fa-rotate-180"></i>
                        Join Room</button>
                </div>
                <div class="col-6">
                    <button class="danger-btn btn-lg float-right" (click)="notAttendCall()"><i
                            class="fa fa-phone fa-lg"></i> {{'button.cancel' | translate | async }} </button>
                </div>
            </div>
        </ng-container>
    </div>
</div>